// extracted by mini-css-extract-plugin
export default {"historySection":"StudentNotesHistoryPanel_historySection__u4Xsl"};